import React, { useEffect, useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import PrettyContainer from "../../prettyContainer/PrettyContainer";
import { getAllApplications, setApplicationsUseAlternativeURL } from "../../../helpers/api";

const AZUL = "#3790ed";
const AZUL_OSCURO = "#1c6fc4";
const MUTED = "#6b7a90";
const PRODEMAND_ID = 6;

export default function ProDemandSourcePage() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [useAlt, setUseAlt] = useState(false); // false = Company, true = Laptop
  const [msg, setMsg] = useState({ type: "", text: "" });

  const cargar = () => {
    setLoading(true);
    getAllApplications()
      .then((res) => {
        const apps = Array.isArray(res) ? res : (res && res.applications) || [];
        const pd = apps.find((a) => Number(a.id) === PRODEMAND_ID);
        setUseAlt(!!(pd && pd.useAlternative));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    cargar();
  }, []);

  const cambiar = (nuevoUseAlt) => {
    if (nuevoUseAlt === useAlt || saving) return;
    setMsg({ type: "", text: "" });
    setSaving(true);
    setApplicationsUseAlternativeURL({ appId: PRODEMAND_ID, useAlternative: nuevoUseAlt })
      .then(() => {
        setSaving(false);
        setUseAlt(nuevoUseAlt);
        setMsg({
          type: "success",
          text: nuevoUseAlt
            ? "ProDemand now uses the Laptop session."
            : "ProDemand now uses the Company account.",
        });
      })
      .catch(() => {
        setSaving(false);
        setMsg({ type: "warning", text: "Could not change the source. Please try again." });
      });
  };

  const opcion = (activo, titulo, sub, onClick) => (
    <button
      onClick={onClick}
      disabled={saving}
      style={{
        flex: 1,
        textAlign: "left",
        padding: "16px 18px",
        borderRadius: "14px",
        border: activo ? `2px solid ${AZUL}` : "2px solid #e6ebf2",
        background: activo ? "#eef4fd" : "#fff",
        cursor: saving ? "not-allowed" : "pointer",
        minWidth: 0,
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontWeight: 800, color: "#1d2735" }}>{titulo}</span>
        {activo && (
          <span
            style={{
              fontSize: "0.68rem",
              fontWeight: 700,
              letterSpacing: "0.05em",
              color: "#fff",
              background: AZUL,
              borderRadius: "999px",
              padding: "3px 10px",
            }}
          >
            IN USE
          </span>
        )}
      </div>
      <div style={{ color: MUTED, fontSize: "0.85rem", marginTop: "4px" }}>{sub}</div>
    </button>
  );

  return (
    <PrettyContainer tittle="PRODEMAND SOURCE">
      <div style={{ paddingTop: "0.6em" }}>
        <p style={{ color: MUTED }}>
          Choose which ProDemand access all clients use. If the Company account gets
          blocked by Mitchell, switch to the Laptop session. The change is instant for
          everyone.
        </p>

        {loading ? (
          <div style={{ textAlign: "center", padding: "20px", color: MUTED }}>
            <Spinner animation="border" size="sm" /> Loading…
          </div>
        ) : (
          <>
            {msg.text && <Alert variant={msg.type}>{msg.text}</Alert>}
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
              {opcion(
                !useAlt,
                "Company account",
                "The reseller account (WorkshopData / Ford PTS). Default.",
                () => cambiar(false)
              )}
              {opcion(
                useAlt,
                "Laptop session",
                "The ProDemand running on our home laptop (residential IP).",
                () => cambiar(true)
              )}
            </div>
            {saving && (
              <div style={{ color: MUTED, fontSize: "0.85rem", marginTop: "10px" }}>
                <Spinner animation="border" size="sm" /> Switching…
              </div>
            )}
          </>
        )}
      </div>
    </PrettyContainer>
  );
}
